import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Form, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyKitSchemaManagement from "./UpdateStudyKitSchemaManagement";
import AddNewStudyKitSchemaManagement from "./AddNewStudyKitSchemaManagement";
import DeletedStudyKitSchemaManagement from "./DeletedStudyKitSchemaManagement";
import StudyKitSchemaManagementActivities from "./StudyKitSchemaManagementActivities";
import { eiwrsKitSchemaManagementServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitSchemaManagementServices";

const StudyKitSchemaManagementDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [kitSchemaData, setKitSchemaData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [kitSchemaList, setKitSchemaList] = useState([]);
  const [kitSchemaCount, setKitSchemaCount] = useState(0);
  const [deletedStudySiteKitSchema, setDeletedStudyKitSchema] = useState([]);
  const [deletedStudySiteKitSchemaCount, setDeletedStudyKitSchemaCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [kitSchemaId, setKitSchemaId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [kitSchemaActivity, setKitSchemaActivity] = useState([]);
  const [kitSchemaActivityCount, setKitSchemaActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(kitSchemaCount / itemsPerPage);

  const getEIWRSKitSchemaManagementData = async (e) => {
    setLoading(true);
    let data = await eiwrsKitSchemaManagementServices.getEIWRSKitSchemaManagementData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setKitSchemaList(data?.data || []);
    setKitSchemaCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSKitSchemaManagementData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsKitSchemaManagementServices.getEIWRSKitSchemaManagementData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyKitSchema(data?.data || []);
    setDeletedStudyKitSchemaCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSKitSchemaManagement",
      studyId,
      kitSchemaData?.kitSchemaId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setKitSchemaActivity(data?.data || []);
    setKitSchemaActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [kitSchemaData]);

  useEffect(() => {
    getEIWRSKitSchemaManagementData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSKitSchemaManagement = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Kit Schema!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsKitSchemaManagementServices.softDeleteRestoreEIWRSKitSchemaManagement(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSKitSchemaManagementData();
          setKitSchemaId("");
          getDeletedEIWRSKitSchemaManagementData();
          if (type === "restore") {
            getDeletedEIWRSKitSchemaManagementData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setKitSchemaId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {kitSchemaCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteKitSchemaCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSKitSchemaManagementData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={kitSchemaId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyKitSchemaManagement getEIWRSKitSchemaManagementData={getEIWRSKitSchemaManagementData} />
          )}
          {loading ? (
            <PageLoader />
          ) : kitSchemaCount === 0 ? (
            <NoDataFoundTable MSG={"Study Kit Schema not found!"} />
          ) : kitSchemaList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Kit Schema not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Schema Name
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>
                      Prefix
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>
                      Starting Number
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>
                      Suffix
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>
                      Joiner
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 6)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 7)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {kitSchemaList?.map((kitSchemaData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${kitSchemaData?.type !== "predefine" && "CP"} ${kitSchemaId === kitSchemaData?._id ? "highlighted" : ""
                        }`}
                      onClick={() => setIsFormOpen(false)}
                    >
                      <td
                        onClick={() => {
                          setKitSchemaData(kitSchemaData);
                          setKitSchemaId(kitSchemaData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      <td
                        onClick={() => {
                          setKitSchemaData(kitSchemaData);
                          setKitSchemaId(kitSchemaData?._id);
                        }}
                      >
                        {kitSchemaData?.schemaName}
                      </td>
                      <td
                        onClick={() => {
                          setKitSchemaData(kitSchemaData);
                          setKitSchemaId(kitSchemaData?._id);
                        }}
                      >
                        {kitSchemaData?.kitPrefix || ""}
                      </td>
                      <td
                        onClick={() => {
                          setKitSchemaData(kitSchemaData);
                          setKitSchemaId(kitSchemaData?._id);
                        }}
                      >
                        {kitSchemaData?.kitStartingNumber}
                      </td>
                      <td
                        onClick={() => {
                          setKitSchemaData(kitSchemaData);
                          setKitSchemaId(kitSchemaData?._id);
                        }}
                      >
                        {kitSchemaData?.kitSufix || ""}
                      </td>
                      <td
                        onClick={() => {
                          setKitSchemaData(kitSchemaData);
                          setKitSchemaId(kitSchemaData?._id);
                        }}
                      >
                        {kitSchemaData?.kitJoiner || ""}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Update ${kitSchemaData?.kitSchema}`}
                        onClick={(e) => {
                          setKitSchemaData(kitSchemaData);
                          setToggle();
                          e.stopPropagation();
                        }}
                        style={{ pointerEvents: "auto" }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${kitSchemaData?.kitSchema}`}
                        onClick={(e) => {
                          softDeleteRestoreEIWRSKitSchemaManagement(
                            kitSchemaData?._id,
                            "delete"
                          );
                        }}
                      >
                        <FaTrash className={"text-danger"} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={kitSchemaCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {kitSchemaId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setKitSchemaId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyKitSchemaManagementActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                kitSchemaActivity={kitSchemaActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                kitSchemaData={kitSchemaData}
                kitSchemaActivityCount={kitSchemaActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyKitSchemaManagement
        Show={!toggle}
        Hide={setToggle}
        kitSchemaData={kitSchemaData}
        setKitSchemaId={setKitSchemaId}
        getEIWRSKitSchemaManagementData={getEIWRSKitSchemaManagementData}
        Title={"Update Study Kit Schema"}
      />
      <DeletedStudyKitSchemaManagement
        Show={!toggle1}
        Hide={setToggle1}
        setKitSchemaId={setKitSchemaId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteKitSchema={deletedStudySiteKitSchema}
        getDeletedEIWRSKitSchemaManagementData={getDeletedEIWRSKitSchemaManagementData}
        deletedStudySiteKitSchemaCount={deletedStudySiteKitSchemaCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSKitSchemaManagement={softDeleteRestoreEIWRSKitSchemaManagement}
        Title={"Deleted Study Kit Schema History"}
      />
    </>
  );
};

export default StudyKitSchemaManagementDataList;
